const UPDATES = [
  { date: '07-31', title: '《极限追凶》高清完整版上线', tag: '新片速递', accent: true },
  { date: '07-30', title: '暑期档动作片合集新增12部影片', tag: '片单更新', accent: false },
  { date: '07-29', title: '播放引擎升级，4K超清画质全面支持', tag: '系统优化', accent: false },
  { date: '07-28', title: '《笑花开局》喜剧片超清版更新', tag: '新片速递', accent: true },
  { date: '07-27', title: '港片经典专区上线，89部经典回归', tag: '专题上线', accent: false },
  { date: '07-26', title: '移动端播放器优化，加载速度提升40%', tag: '系统优化', accent: false },
  { date: '07-25', title: '《星际征途：新纪元》科幻巨制登陆', tag: '新片速递', accent: true },
  { date: '07-24', title: '悬疑片专题整理完成，36部烧脑佳作', tag: '片单更新', accent: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2">97影视最新片源更新与功能动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {UPDATES.map((item, idx) => (
            <div key={idx} className="flex items-start gap-4 pb-4 last:pb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-2 h-2 rounded-full mt-2 ${
                  item.accent ? 'bg-accent-500' : 'bg-primary-500'
                }`} />
                {idx < UPDATES.length - 1 && (
                  <div className="w-px h-full min-h-[16px] bg-background-200/60 mt-1" />
                )}
              </div>

              <div className="flex-1 min-w-0 pb-3">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                  <span
                    className={`px-1.5 py-0.5 text-[10px] font-medium rounded ${
                      item.accent
                        ? 'bg-accent-500/15 text-accent-500'
                        : 'bg-primary-500/15 text-primary-500'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-700">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}